// JavaScript fix for Google Password Manager autofill overlap
export const fixAutofillOverlap = () => {
  // Function to check and fix autofill overlap
  const checkAutofill = () => {
    const inputs = document.querySelectorAll('input[type="email"], input[type="password"]');
    
    inputs.forEach(input => {
      if (input.matches(':-webkit-autofill')) {
        // Find the associated label
        const label = input.closest('.MuiTextField-root')?.querySelector('.MuiInputLabel-root') ||
                     input.closest('.MuiFormControl-root')?.querySelector('.MuiInputLabel-root');
        
        if (label) {
          // Force label to shrink position when autofilled
          label.style.zIndex = '10';
          label.style.backgroundColor = 'white';
          label.style.padding = '0 8px';
          label.style.transform = 'translate(14px, -9px) scale(0.75)';
          label.style.color = 'rgba(0, 0, 0, 0.6)';
          label.classList.add('Mui-focused');
          label.classList.add('MuiInputLabel-shrink');
        }
      }
    });
  };

  // Check on page load
  checkAutofill();

  // Check when inputs are focused/blurred
  document.addEventListener('focusin', checkAutofill);
  document.addEventListener('focusout', checkAutofill);

  // Check periodically for autofill changes
  const interval = setInterval(checkAutofill, 200);

  // Cleanup function
  return () => {
    clearInterval(interval);
    document.removeEventListener('focusin', checkAutofill);
    document.removeEventListener('focusout', checkAutofill);
  };
};

// Auto-fix on DOM ready
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAutofillOverlap);
  } else {
    fixAutofillOverlap();
  }
}
